/// <amd-module name="Wit/UI/PagedWorkItemsList/index" />
export { IPagedWorkItemsList } from "./IPagedWorkItemsList";
export * from "./PagedWorkItemsList";
